import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "has-text-weight-bold is-size-4" }, "Novo Goldyocks"),
  /*#__PURE__*/_createElementVNode("p", { class: "is-size-6" }, "Crie aqui uma nova aplicação.")
], -1)
const _hoisted_2 = { class: "card mt-6" }
const _hoisted_3 = { class: "card-content" }
const _hoisted_4 = { class: "columns" }
const _hoisted_5 = { class: "column is-6-desktop is-12-mobile" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "nif-input"
}, "NIF", -1)
const _hoisted_8 = { class: "control" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", {
  id: "nif-help",
  class: "help"
}, "Número de Identificação Fiscal (9 dígitos)", -1)
const _hoisted_10 = {
  key: 0,
  id: "nif-error",
  class: "help is-danger"
}
const _hoisted_11 = { class: "columns" }
const _hoisted_12 = { class: "column is-6-desktop is-12-mobile" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "alias-input"
}, "Alias", -1)
const _hoisted_15 = { class: "control" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", {
  id: "alias-help",
  class: "help"
}, "Apenas letras, números, hífens e underscores (3-50 caracteres)", -1)
const _hoisted_17 = {
  key: 0,
  id: "alias-error",
  class: "help is-danger"
}
const _hoisted_18 = { class: "card mt-3" }
const _hoisted_19 = { class: "card-content" }
const _hoisted_20 = { class: "card mt-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header-title" }, "Plano a utilizar")
], -1)
const _hoisted_22 = { class: "card-content" }
const _hoisted_23 = { class: "columns is-multiline" }
const _hoisted_24 = { class: "column is-6-desktop is-12-tablet is-12-mobile" }
const _hoisted_25 = { class: "field" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "plan-select"
}, "Plano", -1)
const _hoisted_27 = { class: "control" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  value: "0",
  disabled: ""
}
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Não foi possível carregar os planos. ")
const _hoisted_33 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_34 = {
  key: 0,
  class: "column is-6-desktop is-12-tablet is-12-mobile content"
}
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "card mt-3" }
const _hoisted_37 = { class: "card-content has-text-right" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("strong", null, "Criar", -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Goldylocks")
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_AddressFields = _resolveComponent("AddressFields")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createGoldylocks && _ctx.createGoldylocks(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    id: "nif-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dadosEmpresa.nif_goldylocks) = $event)),
                    onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateNifInput && _ctx.validateNifInput(...args))),
                    class: _normalizeClass(["input has-text-centered", {'is-danger': _ctx.dadosEmpresa.nif_goldylocks && !_ctx.isNifValid}]),
                    type: "text",
                    placeholder: "999999999",
                    maxlength: "9",
                    required: "",
                    "aria-describedby": "nif-help nif-error"
                  }, null, 34), [
                    [_vModelText, _ctx.dadosEmpresa.nif_goldylocks]
                  ])
                ]),
                _hoisted_9,
                (_ctx.dadosEmpresa.nif_goldylocks && !_ctx.isNifValid)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, "O NIF deve conter exatamente 9 dígitos numéricos"))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    id: "alias-input",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dadosEmpresa.alias_goldylocks) = $event)),
                    onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validateAliasInput && _ctx.validateAliasInput(...args))),
                    class: _normalizeClass(['input has-text-centered', {'is-danger': _ctx.dadosEmpresa.alias_goldylocks && !_ctx.isAliasValid}]),
                    type: "text",
                    placeholder: "aminhaempresa",
                    maxlength: "50",
                    required: "",
                    "aria-describedby": "alias-help alias-error"
                  }, null, 34), [
                    [_vModelText, _ctx.dadosEmpresa.alias_goldylocks]
                  ])
                ]),
                _hoisted_16,
                (_ctx.dadosEmpresa.alias_goldylocks && !_ctx.isAliasValid)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, "O alias deve conter apenas letras, números, hífens e underscores (3-50 caracteres)"))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode(_component_FormInput, {
            id: "nome-input",
            label: "Nome empresa",
            modelValue: _ctx.dadosEmpresa.nome_goldylocks,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dadosEmpresa.nome_goldylocks) = $event)),
            placeholder: "Empresa demonstrativa, Lda",
            "max-length": "100",
            required: "",
            "custom-validator": (value) => value.length >= 2 && value.length <= 100
          }, null, 8, ["modelValue", "custom-validator"]),
          _createVNode(_component_FormInput, {
            id: "morada-input",
            label: "Morada",
            modelValue: _ctx.dadosEmpresa.morada_goldylocks,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dadosEmpresa.morada_goldylocks) = $event)),
            placeholder: "Rua de teste, Nº 85",
            "max-length": "150",
            required: "",
            "custom-validator": (value) => value.length >= 5 && value.length <= 150
          }, null, 8, ["modelValue", "custom-validator"]),
          _createVNode(_component_AddressFields, {
            "postal-code": _ctx.dadosEmpresa.cp_goldylocks,
            city: _ctx.dadosEmpresa.localidade_goldylocks
          }, null, 8, ["postal-code", "city"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_FormInput, {
            id: "email-input",
            label: "Email do responsável",
            modelValue: _ctx.dadosEmpresa.email,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dadosEmpresa.email) = $event)),
            type: "email",
            placeholder: "gerencia@empresa.pt",
            "max-length": "100",
            required: "",
            "validation-pattern": /^[^\s@]+@[^\s@]+\.[^\s@]+$/
          }, null, 8, ["modelValue", "validation-pattern"])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["select is-fullwidth", {'is-loading': _ctx.isLoadingPlans}])
                  }, [
                    _withDirectives(_createElementVNode("select", {
                      id: "plan-select",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dadosEmpresa.plan_id) = $event)),
                      disabled: _ctx.isLoadingPlans || _ctx.plansLoadError,
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.isLoadingPlans ? 'Carregando planos...' : _ctx.plansLoadError ? 'Erro ao carregar planos' : 'Selecione um plano...'), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlyPlans, (plan) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: plan.codigo_plano,
                          value: plan.id_plano
                        }, _toDisplayString(_ctx.sanitizeTextInput(plan.nome_plano)), 9, _hoisted_30))
                      }), 128))
                    ], 8, _hoisted_28), [
                      [_vModelSelect, _ctx.dadosEmpresa.plan_id]
                    ])
                  ], 2)
                ]),
                (_ctx.plansLoadError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fetchPlans && _ctx.fetchPlans(...args)), ["prevent"])),
                        class: "has-text-link"
                      }, "Tentar novamente")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.dadosEmpresa.plan_id > 0 && _ctx.selectedPlanInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("p", null, "Valor mensal: € " + _toDisplayString(_ctx.selectedPlanInfo['valor_mensal']), 1),
                    _createElementVNode("p", null, "Valor anual: € " + _toDisplayString(_ctx.selectedPlanInfo['valor_anual']), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.dadosEmpresa.plan_id > 0 && _ctx.selectedPlanInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.selectedPlanInfo['designacao_html']
                  }, null, 8, _hoisted_35)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("button", {
            class: _normalizeClass(["button is-success", {'is-loading': _ctx.isCreating}]),
            disabled: !_ctx.isFormValid,
            "aria-label": "Criar nova aplicação Goldylocks"
          }, _hoisted_41, 10, _hoisted_38)
        ])
      ])
    ], 32)
  ]))
}